import Box from '@app/components/common/Box';
import { formatMoney } from '@westondev/tableturn-core';
import { useContext } from 'react';
import { WithTranslation } from 'react-i18next';
import { EmployeesScreenContext } from '../../../EmployeesContext';
import AmountRow from '../AmountRow';
import { AmountTotalsStyles } from './styles';

const AmountTotals = ({ t }: WithTranslation) => {
  const { employeeSummary } = useContext(EmployeesScreenContext);
  return (
    <Box csx={AmountTotalsStyles}>
      <AmountRow
        data={[
          t('commonTexts.total'),
          (employeeSummary?.totalHoursWorked || 0).toFixed(2),
          formatMoney(null, employeeSummary?.totalSales || 0),
          formatMoney(null, employeeSummary?.totalTipsEarned || 0),
        ]}
        textProps={{
          variant: 'subtitle',
          color: 'semanticBlue',
        }}
        isHeader
      />
    </Box>
  );
};

export default AmountTotals;
